import React, { FC } from 'react'
import Action from './Action'
import Confirmation from './Confirmation'
import * as S from './elements'
import LanguageSwitch from './LanguageSwitch'
import Simple from './Simple'
import Error from './Error'

export type NotificationVariant =
  | 'image-action'
  | 'image-action-undo'
  | 'icon-action'
  | 'icon-action-undo'
  | 'confirmation'
  | 'simple-confirmation'
  | 'error'
  | 'language-switch'

export type ActionProps = {
  variant: 'image-action' | 'image-action-undo' | 'icon-action'
  image?: string
  description: string
  label: string
  sublabel: string
  onClickAction: () => void
  actionLabel: string
}

export type ConfirmationProps = {
  variant: 'confirmation'
  description: string
  label: string
  sublabel?: string
  onClickAction?: () => void
  actionLabel?: string
}

export type SimpleProps = {
  variant: 'simple-confirmation'
  label: string
}

export type ErrorProps = {
  variant: 'error'
  label: string
}

export type LanguageSwitchProps = {
  variant: 'language-switch'
  onClickAction: () => void
}

export type NotificationBody =
  | ActionProps
  | ConfirmationProps
  | SimpleProps
  | ErrorProps
  | LanguageSwitchProps

type Props = { requestClose: () => void }

export type NotificationProps = NotificationBody & Props

export const Notification: FC<NotificationProps> = props => {
  return (
    // The animation can be paused on hover. Once it's finished, request to close the notification
    <S.Container onAnimationEnd={props.requestClose} variant={props.variant}>
      {['image-action', 'image-action-undo', 'icon-action', 'icon-action-undo'].includes(
        props.variant
      ) && (
        <Action
          {...(props as ActionProps)}
          // This ensures that the notification is closed once a button is clicked
          onClickAction={() => {
            ;(props as ActionProps).onClickAction()
            props.requestClose()
          }}
        />
      )}

      {props.variant === 'confirmation' && (
        <Confirmation
          {...(props as ConfirmationProps)}
          onClickAction={() => {
            ;(props as ConfirmationProps).onClickAction()
            props.requestClose()
          }}
        />
      )}

      {props.variant === 'simple-confirmation' && <Simple {...(props as SimpleProps)} />}
      {props.variant === 'error' && <Error {...(props as ErrorProps)} />}

      {props.variant === 'language-switch' && (
        <LanguageSwitch
          {...(props as LanguageSwitchProps)}
          onClickAction={() => {
            ;(props as LanguageSwitchProps).onClickAction()
            props.requestClose()
          }}
        />
      )}
    </S.Container>
  )
}

export default Notification
